import icon from "../../assets/waterdrop.svg";
import type { Property } from "../../types";

export const outdoorReady: Property = {
  id: "outdoorReady",
  title: "outdoorReady.title.1",
  icon,
};
